export enum CustomerStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  PENDING = "p",
  DELETED = "x",
}

export type CustomerStatusTypes = `${CustomerStatusEnum}`;

export interface IListCustomerDTO {
  id: number;
  type: number;
  email: string;
  userName: string;
  name: string;
  documentType: number;
  document: string;
  documentTypeData: string;
  status: CustomerStatusTypes;
  createdAt: Date;
}

export interface ICustomerConfig {
  referral: number;
  limits: string;
  fees: string;
  config: string;
}

export interface ICustomerInfo {
  customer: {
    createdAt: Date;
    updatedAt: Date;
    id: number;
    type: number;
    email: string;
    userName: string;
    name: string;
    documentType: number;
    document: string;
    status: string;
    photos: string;
    blackListData?: {
      customer: number;
      payment: "y" | "n";
      withdraw: "y" | "n";
    };
  };
  encryptedId: string;
  balance: number;
  totalDeposits: number;
  totalWithdraws: number;
  referrals: number;
  config: ICustomerConfig;
  bets: {
    total_bet: number;
    total_won: number;
    total_loss: number;
  };
}

export interface ILog {
  id: number;
  customer: number;
  op: number;
  description: string;
  ip: string;
  browser: string;
  platform: string;
  createdAt: Date;
  opData: {
    id: number;
    description: string;
    createdAt: Date;
  };
}

export interface IDepositHistorical {
  result: {
    id: number;
    trId: number;
    customer: number;
    payinMethod: number;
    dateBuy: Date;
    datePay: Date;
    dateExp: Date;
    fee: number;
    value: number;
    valuePaid: number;
    status: "w" | "p" | "x" | "h";
    payinMethodData: {
      id: number;
      name: string;
      minutesExp: number;
      valueMin: number;
      enabled: string;
      status: string;
      image: string;
      config: string;
    };
  }[];
  currentPage: number;
  pages: number;
}

export interface IWithdrawsHistorical {
  result: {
    id: number;
    customer: number;
    payoutMethod: number;
    account: number;
    value: number;
    fee: number;
    dateRequest: Date;
    dateClose: Date;
    status: "w" | "s" | "p" | "x";
    payoutId: string;
    accountData: string;
    approvalAdm: number;
    note: string;
    bankData: string;
    payoutMethodData: {
      id: number;
      name: string;
      status: string;
      data: string;
    };
  }[];
  currentPage: number;
  pages: number;
}

export interface ICustomerStatusDTO {
  status: string;
  text: string;
  title: string;
  color: string;
}

export interface IBetsHistorical {
  result: {
    createdAt: Date;
    updatedAt: Date;
    id: string;
    customer: number;
    game: number;
    round: string;
    amount: number;
    balance: number;
    profit: number;
    houseFee: number;
    providerFee: number;
    status: "p" | "x" | "w" | "hw" | "hl" | "l";
    gameData: {
      createdAt: Date;
      updatedAt: Date;
      id: number;
      type: number;
      name: string;
      config: string;
      photos: string;
    };
  }[];
  currentPage: number;
  pages: number;
}
